import {Flex, Text} from "@chakra-ui/react";
import StatusBadge from "./StatusBadge";
import {useEffect} from "react";
import {fetchProjectDetails} from "../pages/Workspace/DesignTab/utils";
import {useParams} from "react-router-dom";

const ProjectTitle = ({name, status, refreshProject, region, activeTab}) => {
    const {projectId} = useParams();
    useEffect(() => {
        refreshProject();
    }, [activeTab]);

    return (
        <Flex  pl={6} gap={2} flex={1} direction={"row"} alignItems={"center"} >
            <Text fontWeight={"bold"} fontSize={"xl"}>{name}</Text>
            <StatusBadge status={status} region={region}/>
        </Flex>
    )
}

export default ProjectTitle;